import type { ReactElement } from 'react';
import {
  ReceiptLongOutlined,
  PaymentsOutlined,
  AttachMoney,
} from '@mui/icons-material';
import theme from '../../../theme/theme';

/** Sibling consultation sections of the Paiement tab. */
export type PaymentSectionKey = 'payslips' | 'advances' | 'loans';

export interface PaymentSectionDef {
  key: PaymentSectionKey;
  /** i18n key (namespace `common`) for the section label. */
  labelKey: string;
  /** Icon shown in the sub-navigation tab. */
  icon: ReactElement;
  /** Larger icon shown in the section's empty / coming-soon state. */
  emptyIcon: ReactElement;
}

export const PAYMENT_SECTIONS: PaymentSectionDef[] = [
  {
    key: 'payslips',
    labelKey: 'sections.payslips',
    icon: <ReceiptLongOutlined sx={{ fontSize: theme.iconSize.md }} />,
    emptyIcon: <ReceiptLongOutlined sx={{ fontSize: theme.iconSize.md }} />,
  },
  {
    key: 'advances',
    labelKey: 'sections.advances',
    icon: <PaymentsOutlined sx={{ fontSize: theme.iconSize.md }} />,
    emptyIcon: <PaymentsOutlined sx={{ fontSize: theme.iconSize.md }} />,
  },
  {
    key: 'loans',
    labelKey: 'sections.loans',
    // The `$` glyph is thin and centred in its 24px box (extra whitespace on the
    // right), so it needs less margin than the fuller icons — trim the icon→label
    // gap for this one only. (Sub-nav icon only; the empty-state icon is centred.)
    icon: <AttachMoney sx={{ fontSize: theme.iconSize.md}} />,
    emptyIcon: <AttachMoney sx={{ fontSize: theme.iconSize.md }} />,
  },
];
